import { render } from "./contragent_files.vue?vue&type=template&id=44d8b160"
import script from "./contragent_files.vue?vue&type=script&lang=js"
export * from "./contragent_files.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/users/profile/files/contragent_files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44d8b160"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44d8b160', __exports__)) {
    console.log('reload')
    api.reload('44d8b160', __exports__)
  }
  
  module.hot.accept("./contragent_files.vue?vue&type=template&id=44d8b160", () => {
    console.log('re-render')
    api.rerender('44d8b160', render)
  })

}


export default __exports__